import type { OperatorProjectAppearance } from "@maito/contracts";

export const DEFAULT_WORKSPACE_APPEARANCE: OperatorProjectAppearance = "neutral";
export const WORKSPACE_APPEARANCE_ENABLED = false;

export const WORKSPACE_APPEARANCES: ReadonlyArray<{
  readonly id: OperatorProjectAppearance;
  readonly label: string;
  readonly gradient: string;
  readonly swatch: string;
}> = [
  {
    id: "neutral",
    label: "Neutral",
    gradient: "linear-gradient(to bottom, #E5E4E4, #EEEEED)",
    swatch: "#262626",
  },
  {
    id: "mint",
    label: "Mint",
    gradient: "linear-gradient(to bottom, #CDE8DC, #EFF8F4)",
    swatch: "#00B98A",
  },
  {
    id: "sky",
    label: "Sky",
    gradient: "linear-gradient(to bottom, #C9DCEC, #F1F5F9)",
    swatch: "#078EC7",
  },
  {
    id: "lavender",
    label: "Lavender",
    gradient: "linear-gradient(to bottom, #D1D0E2, #F3F2F6)",
    swatch: "#5E59AA",
  },
  {
    id: "amber",
    label: "Amber",
    gradient: "linear-gradient(to bottom, #F5E6CA, #FBFAF6)",
    swatch: "#F5A900",
  },
  {
    id: "rose",
    label: "Rose",
    gradient: "linear-gradient(to bottom, #F1D9DD, #FCFCFC)",
    swatch: "#DF6D84",
  },
  {
    id: "red",
    label: "Red",
    gradient: "linear-gradient(to bottom, #EDD0D0, #FAF7F7)",
    swatch: "#D04955",
  },
  {
    id: "orange",
    label: "Orange",
    gradient: "linear-gradient(to bottom, #F3D7CC, #FBF9F8)",
    swatch: "#ED6838",
  },
];

export function getWorkspaceAppearance(appearance: OperatorProjectAppearance | undefined) {
  if (!WORKSPACE_APPEARANCE_ENABLED) return WORKSPACE_APPEARANCES[0]!;
  return (
    WORKSPACE_APPEARANCES.find((candidate) => candidate.id === appearance) ??
    WORKSPACE_APPEARANCES[0]!
  );
}
